import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Button from './Button';
import heroBg from '../assets/images/hero-bg.jpg';
import logo from '../assets/images/logo.png';

const HeroSection = styled.section`
  height: 100vh;
  background: linear-gradient(rgba(18, 25, 16, 0.8), rgba(18, 25, 16, 0.9)), url(${heroBg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 80px;
`;

const HeroContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  
  @media (max-width: 991px) {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
`;

const HeroContent = styled.div`
  max-width: 600px;
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.6s ease-out forwards;
  
  @media (max-width: 991px) {
    max-width: 100%;
    order: 2;
  }
`;

const LogoContainer = styled.div`
  max-width: 400px;
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.6s ease-out 0.3s forwards;
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  @media (max-width: 991px) {
    max-width: 250px;
    order: 1;
  }
`;

const Title = styled.h1`
  margin-bottom: 15px;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  
  span {
    color: var(--secondary-color);
  }
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
  
  @media (max-width: 576px) {
    font-size: 2.2rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: var(--light-color);
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  margin-bottom: 40px;
  color: var(--light-color);
  
  @media (max-width: 576px) {
    font-size: 1rem;
  }
`;

const StyledButton = styled(Button)`
  &:hover {
    transform: translateY(-3px);
  }
`;

const Hero = () => {
  return (
    <HeroSection id="hero">
      <div className="container">
        <HeroContainer>
          <HeroContent>
            <Title>DEV TEAM <span>SIX</span></Title>
            <Subtitle>ELITE EM DESENVOLVIMENTO</Subtitle>
            <Description>Soluções tecnológicas inovadoras com precisão, excelência e integridade</Description>
            <Link to="/contact">
              <StyledButton>INICIAR MISSÃO</StyledButton>
            </Link>
          </HeroContent>
          <LogoContainer>
            <img src={logo} alt="Dev Team Six Logo" />
          </LogoContainer>
        </HeroContainer>
      </div>
    </HeroSection>
  );
};

export default Hero;
